export default __webpack_public_path__ + "static/media/waitingForConfirmation.4944488a.svg";